module.exports = __webpack_public_path__ + "static/media/sidebar-email-selected.f44ffcf2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/sidebar-email-selected.svg
// module id = 792
// module chunks = 0